import { render, staticRenderFns } from "./ShowAllOrders.vue?vue&type=template&id=9f17d4c4&"
import script from "./ShowAllOrders.vue?vue&type=script&lang=js&"
export * from "./ShowAllOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports